import ForgotPasswordForm from '../../components/ForgotPassword/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  return (
    <div>
      <ForgotPasswordForm />
    </div>
  );
};

export default ForgotPasswordPage;
